import { mapState, mapMutations } from "vuex";
import * as d3 from 'd3';


var homeHolderMixin = {
  data(){
    return {
      fetches: 0,
      is_init: undefined,
      curr_view_ready: false,
    }
  },
  computed:{
    ...mapState({      
      valid_periods: state => state.valid_periods,      
      ejes: state => state.ejes,      
      indicadores: state => state.indicadores,      
      last_values: state => state.last_values,
      ises: state => state.ises,      
      loading_update: state => state.loading_update,      
    }),
  },
  watch:{
    show_charts(after){
      //console.log("show_charts", after)
      if (after && this.is_init === false){
        try{
          this.updateAxis()
        }
        catch(err){
          //console.log(err)
        }
        setTimeout(() => {
          if (this.$refs.stack)
            this.$refs.stack.reflow()
        }, 2000)
      }
    },
    loading_update(after){
      if (after && this.is_init == false){
        try{
          this.updateAxis()
        }
        catch(err){
          //console.log(err)
        }
        setTimeout(() => {
          if (this.$refs.stack)
            this.$refs.stack.reflow()
        }, 2000)
      }
    },
  },
  methods: {
    ...mapMutations({
      setInitReady : 'SET_INIT_READY',
      setViewReady : 'SET_VIEW_READY',
    }),
    getHomeCats(extras = []){
      //let this.view_type = extras.length ? 'view' : 'initial'
      this.is_init = !extras.length
      //console.log("getHomeCats")
      this.fetches = 0
      //console.log(this.fetches)
      //console.log(extras)
      let initial_comprobs = [
        {'state': 'ises', 'method': 'FETCH_ISES'},
        {'state': 'valid_periods', 'method': 'FETCH_VALID_PERIODS'},
        {'state': 'ejes', 'method': 'FETCH_CAT_INDICADORES'},
      ]
      if (this.is_init)
        this.setInitReady(false)
      else{
        //console.log("llego a poner esto en false")
        this.setViewReady(false)
      }
      let comprobs = this.is_init ? initial_comprobs : extras
      let fetches_count = comprobs.length
      //console.log(this.fetches)
      comprobs.forEach(com=>{
        if (this[com.state] && !this.is_init && !com.eachPetition){
          this.checkTypeReady(fetches_count)
        }
        else
          this.$store.dispatch(com.method).then(()=>{
            this.checkTypeReady(fetches_count)
          })
      })
    },
    checkTypeReady(fetches_count){
      //console.log("checkTypeReady")
      this.fetches++
      //console.log(this.fetches >= fetches_count)
      if (this.fetches >= fetches_count){
        if (this.is_init)
          this.setInitReady(true)
        else
          this.setViewReady(true)
      }
    },
  },
}

export default homeHolderMixin;
